import Vue from "vue";
const dayjs = require("dayjs");
const localizedFormat = require("dayjs/plugin/localizedFormat");
dayjs.extend(localizedFormat);
const language = navigator.language.toLocaleLowerCase();
const allLanguagesStr = 'tzl,tzm,tzm-latn,ug-cn,uk,ur,uz,uz-latn,vi,x-pseudo,yo,zh,zh-cn,zh-hk,zh-tw,af,am,ar,ar-dz,ar-iq,ar-kw,ar-ly,ar-ma,ar-sa,ar-tn,az,be,bg,bi,bm,bn,bn-bd,bo,br,bs,ca,cs,cv,cy,da,de,de-at,de-ch,dv,el,en,en-au,en-ca,en-gb,en-ie,en-il,en-in,en-nz,en-sg,en-tt,eo,es,es-do,es-mx,es-pr,es-us,et,eu,fa,fi,fo,fr,fr-ca,fr-ch,fy,ga,gd,gl,gom-latn,gu,he,hi,hr,ht,hu,hy-am,id,is,it,it-ch,ja,jv,ka,kk,km,kn,ko,ku,ky,lb,lo,lt,lv,me,mi,mk,ml,mn,mr,ms,ms-my,mt,my,nb,ne,nl,nl-be,nn,oc-lnc,pa-in,pl,pt,pt-br,rn,ro,ru,rw,sd,se,si,sk,sl,sq,sr,sr-cyrl,ss,sv,sv-fi,sw,ta,te,tet,tg,th,tk,tlh,tl-ph,tr'
const allLanguages = allLanguagesStr.split(',')
require("dayjs/locale/tzl")
require("dayjs/locale/tzm")
require("dayjs/locale/tzm-latn")
require("dayjs/locale/ug-cn")
require("dayjs/locale/uk")
require("dayjs/locale/ur")
require("dayjs/locale/uz")
require("dayjs/locale/uz-latn")
require("dayjs/locale/vi")
require("dayjs/locale/x-pseudo")
require("dayjs/locale/yo")
require("dayjs/locale/zh")
require("dayjs/locale/zh-cn")
require("dayjs/locale/zh-hk")
require("dayjs/locale/zh-tw")
require("dayjs/locale/af")
require("dayjs/locale/am")
require("dayjs/locale/ar")
require("dayjs/locale/ar-dz")
require("dayjs/locale/ar-iq")
require("dayjs/locale/ar-kw")
require("dayjs/locale/ar-ly")
require("dayjs/locale/ar-ma")
require("dayjs/locale/ar-sa")
require("dayjs/locale/ar-tn")
require("dayjs/locale/az")
require("dayjs/locale/be")
require("dayjs/locale/bg")
require("dayjs/locale/bi")
require("dayjs/locale/bm")
require("dayjs/locale/bn")
require("dayjs/locale/bn-bd")
require("dayjs/locale/bo")
require("dayjs/locale/br")
require("dayjs/locale/bs")
require("dayjs/locale/ca")
require("dayjs/locale/cs")
require("dayjs/locale/cv")
require("dayjs/locale/cy")
require("dayjs/locale/da")
require("dayjs/locale/de")
require("dayjs/locale/de-at")
require("dayjs/locale/de-ch")
require("dayjs/locale/dv")
require("dayjs/locale/el")
require("dayjs/locale/en")
require("dayjs/locale/en-au")
require("dayjs/locale/en-ca")
require("dayjs/locale/en-gb")
require("dayjs/locale/en-ie")
require("dayjs/locale/en-il")
require("dayjs/locale/en-in")
require("dayjs/locale/en-nz")
require("dayjs/locale/en-sg")
require("dayjs/locale/en-tt")
require("dayjs/locale/eo")
require("dayjs/locale/es")
require("dayjs/locale/es-do")
require("dayjs/locale/es-mx")
require("dayjs/locale/es-pr")
require("dayjs/locale/es-us")
require("dayjs/locale/et")
require("dayjs/locale/eu")
require("dayjs/locale/fa")
require("dayjs/locale/fi")
require("dayjs/locale/fo")
require("dayjs/locale/fr")
require("dayjs/locale/fr-ca")
require("dayjs/locale/fr-ch")
require("dayjs/locale/fy")
require("dayjs/locale/ga")
require("dayjs/locale/gd")
require("dayjs/locale/gl")
require("dayjs/locale/gom-latn")
require("dayjs/locale/gu")
require("dayjs/locale/he")
require("dayjs/locale/hi")
require("dayjs/locale/hr")
require("dayjs/locale/ht")
require("dayjs/locale/hu")
require("dayjs/locale/hy-am")
require("dayjs/locale/id")
require("dayjs/locale/is")
require("dayjs/locale/it")
require("dayjs/locale/it-ch")
require("dayjs/locale/ja")
require("dayjs/locale/jv")
require("dayjs/locale/ka")
require("dayjs/locale/kk")
require("dayjs/locale/km")
require("dayjs/locale/kn")
require("dayjs/locale/ko")
require("dayjs/locale/ku")
require("dayjs/locale/ky")
require("dayjs/locale/lb")
require("dayjs/locale/lo")
require("dayjs/locale/lt")
require("dayjs/locale/lv")
require("dayjs/locale/me")
require("dayjs/locale/mi")
require("dayjs/locale/mk")
require("dayjs/locale/ml")
require("dayjs/locale/mn")
require("dayjs/locale/mr")
require("dayjs/locale/ms")
require("dayjs/locale/ms-my")
require("dayjs/locale/mt")
require("dayjs/locale/my")
require("dayjs/locale/nb")
require("dayjs/locale/ne")
require("dayjs/locale/nl")
require("dayjs/locale/nl-be")
require("dayjs/locale/nn")
require("dayjs/locale/oc-lnc")
require("dayjs/locale/pa-in")
require("dayjs/locale/pl")
require("dayjs/locale/pt")
require("dayjs/locale/pt-br")
require("dayjs/locale/rn")
require("dayjs/locale/ro")
require("dayjs/locale/ru")
require("dayjs/locale/rw")
require("dayjs/locale/sd")
require("dayjs/locale/se")
require("dayjs/locale/si")
require("dayjs/locale/sk")
require("dayjs/locale/sl")
require("dayjs/locale/sq")
require("dayjs/locale/sr")
require("dayjs/locale/sr-cyrl")
require("dayjs/locale/ss")
require("dayjs/locale/sv")
require("dayjs/locale/sv-fi")
require("dayjs/locale/sw")
require("dayjs/locale/ta")
require("dayjs/locale/te")
require("dayjs/locale/tet")
require("dayjs/locale/tg")
require("dayjs/locale/th")
require("dayjs/locale/tk")
require("dayjs/locale/tlh")
require("dayjs/locale/tl-ph")
require("dayjs/locale/tr")

const filters = {
  // 对时间进行格式化
  dateFormat(time) {
    if (allLanguages.includes(language)) {
      dayjs.locale(language);
    }
    return dayjs(time).format("ll");
  }
};

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});



// WEBPACK FOOTER //
// ./src/utils/filter.js